export default __webpack_public_path__ + "static/media/background.55e74a7f.jpg";